
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'

import { getArea, medicalDecList, medicalDecListHis, getAuthority, auditingNo, auditing, auditingP } from '@/api/yiliaohuzhu'

export default {
name: 'workspace',
directives: {
TransferDom
},
components: {
Tab,
TabItem,
XDialog,
XTextarea,
Group
},
data () {
return {
active: 0,
list: [],
pageSize: 7,
pageCurrent: 1,
show1: false,
show2: false,
areaid: [],
type: '',
dlist: [],
checkedid: [],
moremsg: '点击加载更多',
nomore: false,
show: false,
textarea: '',
alllist: [],
qxlist: [],
checked: false
}
},
mounted () {
this.getAreaNow()
this.getAuthorityNow()



},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
watch: {
$route (to, from) {
if (from.name !== 'yiliaohuzhuDown' && to.name !== 'yiliaohuzhuDown') {

}
},
active: function () {
this.getAreaNow()
},
checkedid: function () {
if (this.checkedid.length == this.alllist.length) {
this.checked = true
} else {
this.checked = false
}
}
},
methods: {
getAuthorityNow () {

try {
getAuthority({
accountid: this.accountid
}).then(res => {




}).catch((e) => {
console.log(e)
})
} catch (err) {
console.log(e)
}
},
itemclick (index) {
this.active = index
},
linkzy1 (areaid) {
this.$router.push({ name: 'yiliaohuzhuDetail', params: { areaid: areaid, type: 3 } })
},
linkzy2 (areaid) {
this.$router.push({ name: 'yiliaohuzhuDown', params: { areaid: areaid, type: 3 } })
},
linkzdb1 (areaid) {
this.$router.push({ name: 'yiliaohuzhuDetail', params: { areaid: areaid, type: '1,2' } })
},
linkzdb2 (areaid) {
this.$router.push({ name: 'yiliaohuzhuDown', params: { areaid: areaid, type: '1,2' } })
},
getAreaNow () {
if (this.active == 0) {
getArea({
accountid: this.accountid,
type: '1'
}).then(data => {
this.list = data.obj
data.obj.forEach(item => {
this.areaid.push(item.Gridcode)
})
this.areaid = this.areaid.join(',')
this.getdeclistNow()
})
} else {
getArea({
accountid: this.accountid,
type: '2'
}).then(data => {
this.list = data.obj
data.obj.forEach(item => {
if (item.zyhnum > 0) {
this.$set(item, 'showy1', true) 
this.show2 = true
}
if (item.bdhnum > 0) {
this.$set(item, 'showy2', true) 
this.show2 = true
}
})
})
}
},

getdeclistNow () {

medicalDecList({
accountid: this.accountid,
medicalType: this.type,
area: this.areaid,
pageSize: this.pageSize,
pageCurrent: this.pageCurrent
}).then(res => {
if (res.obj !== null) {
if (res.obj.length > 0) {
this.checked = false
this.dlist = [...this.dlist, ...res.obj]
this.dlist.forEach(obj => {
this.alllist.push(obj.id)
})
this.alllist = Array.from(new Set(this.alllist))
this.moremsg = '点击加载更多'
} else if (this.pageCurrent == 1 && this.dlist.length == 0) {

} else {
this.moremsg = ''
this.nomore = true
}
}
})
},
loadmore () {
if (!this.nomore) {
this.moremsg = '正在加载中...'

this.checkedid = Array.from(new Set(this.checkedid))
this.pageCurrent++
this.getdeclistNow()
}
},
qx () {
if (this.checked) {
this.checkedid = this.alllist
} else {
this.checkedid = []
}
},
audit () {
console.log(this.checkedid)
if (this.checkedid.length == 0) {
this.$vux.alert.show({
content: '您尚未选择！'
})
}
if (this.checkedid.length == 1) {
auditing({
accountid: this.accountid,
id: this.checkedid[0]
}).then(res => {
if (res.success == true) {
this.$vux.alert.show({
content: '审核成功！',
onHide () {
location.reload()
}
})
}
})
}
if (this.checkedid.length > 1) {
auditingP({
accountid: this.accountid,
ids: this.checkedid.join(',')
}).then(res => {
if (res.success == true) {
this.$vux.alert.show({
content: '审核成功！',
onHide () {
location.reload()
}
})
}
})
}
if (this.checked == true) {
auditingP({
accountid: this.accountid,
ids: this.alllist.toString()
}).then(res => {
if (res.success == true) {
this.$vux.alert.show({
content: '审核成功！',
onHide () {
location.reload()
}
})
}
})
}
},
noaudit () {
console.log(this.checkedid)
if (this.checkedid.length == 0) {
this.$vux.alert.show({
content: '您尚未选择！'
})
}
if (this.checkedid.length == 1) {
this.show = true
}
if (this.checkedid.length > 1) {
this.$vux.alert.show({
content: '只能单个拒绝！'
})
}
},
submit () {
if (this.textarea.length == 0) {
this.$vux.toast.text('请填写拒绝理由')
return false
} else {
auditingNo({
accountid: this.accountid,
id: this.checkedid[0],
appreason: this.textarea
}).then(res => {
if (res.success == true) {
this.show = false
this.$vux.alert.show({
content: '退回成功！',
onHide () {
location.reload()
}
})
}
})
}
}
}
}
